import DropzoneContainer from "../../../Components/BonusUi/Dropzone/DropzoneConatiner";

const Dropzone = () => {
  return <DropzoneContainer />;
};

export default Dropzone;
